export const codes = {
	activity: {
		addActivity: 1857,
		activityDetails: 1858,
		ownerBy: 1859,
		editActivity: 1860,
		noActivitiesAvailable: 1864,
		taskWizardTitle: 2016,
		entity: 6535,
		todo: 8649,
		inProgress: 8650,
		done: 8651,
		activityPriority: 8656,
		dueDate: 8657,
		owner: 8711,
		assignee: 8712,
		searchTip: 8713,
		sms: 8733,
		sendSms: 8735,
		textMessage: 8736,
		activityType: 8881,
		showTeamActivities: 8925,
		action: 8938,
		subject: 9327,
		assignedDepartment: 11274,
		assignTo: 11282,
		commentsNotAvailableMessage: 11394,
		assigneeType: 14190,
	},
	common: {
		employer: 5,
		invitePossible: 20,
		specificRoles: 22,
		generalRoles: 23,
		phase: 60,
		action: 111,
		update: 114,
		authenticationSettings: 225,
		created: 226,
		endDateValidationMessage: 234,
		male: 269,
		female: 270,
		notSpecified: 271,
		noAccess: 272,
		read: 274,
		readWrite: 276,
		name: 285,
		email: 301,
		emailExample: 302,
		wrongEmailPleaseTryAgain: 303,
		maximumLengthExceeded: 304,
		lengthIsLessThanRequired: 12947,
		fillIn: 309,
		history: 321,
		by: 322,
		info: 325,
		startDate: 333,
		activate: 394,
		taxCalculatingPeriod: 410,
		notANumber: 416,
		daysBeforeStartDate: 419,
		daysBeforeEndDate: 420,
		wrongCurrency: 426,
		currencyFormat: 427,
		period: 460,
		advancedSearch: 462,
		mobile: 472,
		sorryAnErrorOccurred: 473,
		daily: 478,
		within1hour: 479,
		hhMm: 485,
		upload: 488,
		select: 490,
		newItems: 504,
		top10Items: 505,
		mo: 506,
		tu: 507,
		we: 508,
		th: 509,
		fr: 510,
		sa: 511,
		su: 512,
		none: 535,
		showOldItems: 546,
		minNumber: 547,
		maxNumber: 548,
		url: 549,
		search: 556,
		continue: 582,
		idDocumentNumber: 585,
		idDocumentExpirationDate: 587,
		socialSecurityNumber: 589,
		date: 595,
		invite: 626,
		reason: 679,
		entityGUID: 682,
		yes: 735,
		no: 736,
		details: 737,
		error: 795,
		changesSuccessfullySaved: 801,
		find: 806,
		phoneExample: 813,
		save: 824,
		all: 835,
		from: 838,
		to: 839,
		min: 871,
		max: 872,
		wrongBirthDateFormatMin: 873,
		wrongBirthDateFormatMax: 885,
		charactersAvailable: 886,
		goTo: 904,
		approve: 955,
		reject: 956,
		add: 963,
		active: 969,
		close: 971,
		cannotSendSms: 973,
		new: 1067,
		sortBy: 1172,
		more: 1233,
		title: 1427,
		open: 1600,
		maxNDecimalsAreAllowed: 1669,
		total: 1833,
		noOptionsFound: 1866,
		disable: 2026,
		weekly: 2037,
		monthly: 2038,
		first: 2039,
		second: 2040,
		third: 2041,
		fourth: 2042,
		last: 2043,
		week: 2046,
		n2ndWeek: 2047,
		n3rddWeek: 2048,
		n4thdWeek: 2049,
		before: 2100,
		after: 2101,
		goToMessage: 2134,
		noPresentationAdded: 2135,
		noContactPersonAvailable: 2136,
		noDescription: 2137,
		addPresentation: 2138,
		endDateShouldBeWithinContractPeriod: 2203,
		daysBeforeCreateDate: 2296,
		send: 2392,
		contractPerson: 2409,
		roles: 2403,
		description: 2412,
		initialStatus: 2413,
		summary: 2416,
		previous: 2417,
		next: 2418,
		create: 2419,
		profile: 2433,
		cancel: 2440,
		invoice: 3003,
		periodFrom: 3080,
		periodTo: 3081,
		excelFile: 3010,
		pdfFile: 3011,
		assignment: 3084,
		defaultLanguageValueRequired: 3175,
		or: 3212,
		telephone: 3367,
		viewDocument: 3475,
		selectAll: 3477,
		wrongFileName: 3512,
		owner: 3537,
		inherited: 8896,
		skype: 3591,
		experience: 3616,
		attachments: 4198,
		ownerCandidate: 4473,
		step: 4489,
		of: 4491,
		dateOfBirth: 5013,
		noItemsAvailable: 5135,
		workExperience: 5066,
		addYourCommentHere: 5074,
		showAll: 5205,
		smsSenderName: 5353,
		category: 5516,
		in: 6291,
		showAllVersions: 8628,
		hide: 8854,
		submit: 8865,
		priority: 8951,
		itemsCountIndicator: 8959,
		empty: 9627,
		invalidValue: 9382,
		invalidNumber: 12365,
		replaceCover: 10301,
		uploadCover: 10302,
		removeCover: 10303,
		replaceThumbnail: 10304,
		uploadThumbnail: 10305,
		removeThumbnail: 10306,
		errors: 10340,
		foundErrors: 10341,
		errorsView: 10342,
		errorsHide: 10343,
		saveAndContinue: 10359,
		discardAndContinue: 10360,
		uploadFile: 10399,
		dragAndDropFile1: 10400,
		dragAndDropFile2: 10401,
		unselectAll: 10402,
		selected: 10518,
		emptyFileWarning: 10523,
		currentlyUnavailable: 10589,
		recentItems: 10596,
		additionalFilters: 2098,
		noItemsFound: 2099,
		contact: 9995,
		mustBeGreaterThan: 10705,
		mustBeLessThan: 10707,
		allItems: 10709,
		searchResults: 10710,
		cleanUp: 10779,
		today: 10783,
		yesterday: 10784,
		thisWeek: 10785,
		deleted: 391,
		delete: 443,
		selectedItemsLimitExceededConfirmationMessage: 11163,
		allow: 11275,
		copy: 11284,
		mustBeGreaterThanOrEqualTo: 11334,
		mustBeLessThanOrEqualTo: 11335,
		jobTitle: 11441,
		result: 12000,
		verify: 9869,
		attachFile: 12166,
		zoomIn: 12559,
		zoomOut: 12560,
		zoomReset: 12561,
		documentWithSignatureTip: 16243,
		fullscreen: 12562,
		gridView: 12563,
		anchorView: 12564,
		recipients: 12801,
		includeDoNotEmail: 12802,
		includeNotActiveUsers: 12803,
		includeDoNotEmailDescription: 12806,
		includeNotActiveUsersDescription: 12807,
		defaultRecipientsDescription: 13005,
		sendBulkEmailLimitMessage: 12808,
		access: 12918,
		value: 12929,
		general: 12999,
		customerGuid: 3027,
		companyName: 13620,
		errorsInLowerCase: 13965,
		wrongPhone: 812,
		numberName: 8117,
		wrongHexFormat: 14275,
		invalidUrl: 14337,
		urlProtocolRequired: 14338,
		dateFromShouldBeLessOrEqualThanDateTo: 5548,
		backToList: 14494,
		areYouSure: 14737,
		dropdownItemsOverlapMessage: 14853,
		change: 15019,
		amount: 15027,
		inUse: 15141,
		notInUse: 15142,
		properties: 15287,
		additional: 15288,
		actionGroup: {
			sendSection: 15020,
			addSection: 15021,
			createSection: 15022,
			remainingSection: 15023,
		},
		salary: 15660,
		contactMe: 15739,
		increase: 15787,
		increasing: 15796,
		process: 15805,
		filters: 15806,
		lastUpdate: 15813,
		selectedItems: 15835,
		type: 15849,
		connect: 15947,
		disconnect: 15948,
		juridicalAgency: 15972,
		createdBy: 15974,
		pleaseSpecifyReason: 15975,
		rejectBy: 15976,
		copyIdToClipboard: 16011,
		contractEndReason: 16013,
		candidateNumber: 16043,
		timeFrom: 16120,
		timeTo: 16121,
		createdDate: 16344,
	},
	entities: {
		createDate: 684,
		createDateFrom: 685,
		createDateTo: 686,
		status: 319,
		statusChangedFormat: 320,
		action: 381,
		waiting: 382,
		done: 383,
		rejected: 384,
		progress: 408,
		number: 438,
		version: 463,
		versionStartDate: 436,
		versionEndDate: 437,
		owner: 3537,
		statusUpdate: 1107,
		initialStatus: 2413,
		attributes: 2420,
		statuses: 2421,
		transitions: 2422,
		statusChangeWarning: 3541,
		singular: 8647,
	},
	candidate: 13,
	bureau: 3156,
	cookieAcceptMessage: 48,
	update: 114,
	title: 181,
	search: 229,
	changePassword: 282,
	myProfile: 324,
	label: 330,
	ddMmYyyy: 335,
	ok: 352,
	action: 381,
	upload: 488,
	prefixSurname: 489,
	select: 490,
	save: 824,
	dateFrom: 1039,
	dateTo: 1040,
	comments: 5076,
	addComment: 5073,
	addCommentHere: 1450,
	supportedFileExtensions: 1497,
	libraryFilters: 2114,
	uploadProfileImage: 2116,
	copy: 2272,
	currentVersion: 2394,
	more: 2441,
	less: 2442,
	bankAccountNumber: 3368,
	reset: 3526,
	import: 3582,
	phone: 4155,
	maritalState: 5022,
	deleteComment: 5077,
	thisCommentWillBeDeletedPermanently: 5078,
	doYouWantToProceed: 5079,
	delete: 5129,
	edit: 825,
	continueWithCurrentBrowser: 5413,
	fileSizeShouldNotExceedMB: 6043,
	showMore: 6271,
	in: 6291,
	setAsDefault: 6725,
	required: 7224,
	maxLength: 7225,
	cancel: 7265,
	formElements: 7602,
	genericFields: 7603,
	textField: 7604,
	numberField: 7605,
	toggle: 7606,
	checkbox: 7607,
	dateField: 7608,
	slider: 7609,
	textarea: 7610,
	enter: 7611,
	radioButton: 7612,
	markActionRequired: 8636,
	markCompleted: 8620,
	markUnreadForMe: 8623,
	markUnreadFor: 8624,
	markReadForMe: 8625,
	markReadFor: 8635,
	entity: 8647,
	today: 8660,
	addContactPerson: 8748,
	browserNotSupported: 8964,
	upgradeBrowser: 8965,
	browserVersionIndicator: 8966,
	noCommentsAvailable: 8967,
	edited: 8968,
	old: 8969,
	nothingFound: 8970,
	inUse: 9209,
	notInUse: 9210,
	clear: 517,
	sendEmail: 5098,
	addDocument: 1381,
	applications: {
		plural: 4120,
		send: 5107,
		cancel: 5108,
		from: 5103,
		to: 5104,
		subject: 5106,
		cc: 5105,
		reject: 1513,
		rejectReasonInternalUseOnly: 2156,
		specifyReasonOfTheApplicationRejecting: 9377,
		sendNotificationToApplicant: 9378,
		commentTooltip: 9733,
		sendNotificationTooltip: 9734,
		addAnApplication: 9655,
		job: 1396,
		status: 319,
		source: 9429,
		comment: 6506,
		approvalApplicantToUseDataForOtherJobs: 9657,
		add: 963,
		newApplicant: 9638,
		existingApplicant: 9639,
		addApplicationForCandidateIsAlreadyRegistered: 9643,
		addApplicationForCandidateIsNotYetInDatabase: 9640,
		dateOfBirth: 3364,
		rejectTitle: 9376,
		rates: 9464,
		rate: 9466,
		usedApplicationForm: 9470,
		additionallyCommentTooltip: 9744,
		applicantHasAgreedThePrivacyPolicy: 4641,
		applicantHasAgreedHisProfileBeingUsedForVacancies: 9642,
		step: 9745,
		uploadCVDocument: 9746,
		addNewApplicantOrForExistingCandidate: 9747,
		newDocumentName: 9749,
		applicantAgreesPrivacyPolicy: 9641,
	},
	candidates: {
		singular: 13,
		plural: 14,
		candidateType: 893,
		unableToCreateContract: 4036,
		company: 5058,
		location: 5059,
		jobTitle: 5060,
		jobDescription: 5061,
		reasonEnded: 5062,
		comments: 5063,
		throughIntermediary: 5064,
		nameIntermediary: 5065,
		updateMobileSuccessMessage: 5139,
		newMobile: 5152,
		currentMobile: 5153,
		updateExceptionDetailsPopupMessage: 5154,
		candidateChangeRejectModalTitle: 5168,
		candidateChangeRejectModalDescriptionMulti: 5169,
		candidateChangeSendEmailToCandidate: 5170,
		candidateChangeTheseEmailsWillBeSentCandidates: 5171,
		candidateChangeRejectReason: 5172,
		candidateChangeRejectModalDescription: 5175,
		candidateChangeRejectNotificationModalTitle: 5176,
		candidateChangeApproveTitle: 5177,
		candidateChangeApproveDesc: 5178,
		candidateChangeApproveSuccess: 5179,
		candidateEmailEditTitle: 5238,
		candidateEmailEditFirstStepDescription: 5239,
		candidateEmailEditSecondStepDescription: 5240,
		candidateEmailEditOldEmail: 5241,
		candidateEmailEditNewEmail: 5242,
		candidateEmailEditVerifyCode: 5243,
		candidateEmailEditVerifyPinCodeRetryTip: 5245,
		fieldHistory: 5250,
		updateButton: 5247,
		updateButtonOnDetailPage: 5248,
		sendCandidateFormsTitlePopup: 5207,
		sendCandidateFormsFormName: 5208,
		deleteWorkingHistoryItem: 5305,
		deleteWorkingHistoryItemDescription: 5306,
		startDate: 6045,
		endDate: 6046,
		organisationName: 6047,
		levelDescription: 6048,
		degreeMajor: 6049,
		degreeMajorCode: 6050,
		degreeMajorDescription: 6051,
		description: 6052,
		education: 6053,
		educationName: 6054,
		educationLevel: 6055,
		educationType: 6056,
		educationStatus: 6057,
		deleteEducationItem: 6063,
		deleteEducationItemDescription: 6064,
		doYouWantToProceed: 6065,
		customQuestions: 6097,
		question: 6099,
		answer: 6100,
		date: 6101,
		changeMobile: 6547,
		formType: 7684,
		userStatus: 7685,
		sendFormWarningMessage: 7686,
		inviteNewCandidateToRegisterTitle: 8995,
		inviteButton: 8996,
		actionButton: 8997,
		documentType: 8988,
		firstName: 8990,
		middleName: 8991,
		lastName: 8992,
		email: 8993,
		language: 8994,
		formName: 8989,
		office: 8998,
		contactPerson: 8999,
		tagsAndSkills: 9330,
		jobPreferences: 9552,
		sendFormToMultipleCandidates: 7717,
		sendFormToMultipleCandidatesTopMessage: 7718,
		countOfCandidatesThatReceiveForm: 7719,
		countOfCandidatesThatNotReceiveForm: 7720,
		createCandidateContract: 13200,
		mobilePartiallyRequiredBySelectedForm: 13901,
		customQuestionsNoQuestionAnswered: 13981,
	},
	templates: {
		template: 2204,
		addTemplate: 9814,
		templateType: 9812,
		copyFrom: 9813,
		name: 525,
		copyFromToolTip: 9815,
	},
	contracts: {
		singular: 315,
		plural: 316,
		endContract: 4060,
		total: 5124,
		singularOrPlural: 5125,
		rejectedReason: 477,
		cancel: 5108,
		import: 13682,
		whoShouldSign: 1817,
		uploadNewOrPublished: 1818,
		new: 1819,
		published: 1820,
		wizardStep1Tip: 1823,
		wizardStep2Tip: 1824,
		signingBy: 1825,
		documentOwner: 1826,
		required: 300,
		signLevel: 905,
		previous: 2417,
		youShouldChooseOneOption: 5206,
		selectDocument: 1827,
		wizardStep2TipForNew: 1828,
		documentType: 9506,
		country: 2404,
		subtype: 1499,
		select: 490,
		dateTo: 1040,
		dateFrom: 1039,
		supportedFileExt: 1497,
		versionStartDate: 436,
		versionEndDate: 437,
		caoFunctionGroup: 880,
		general: 1120,
		pensionFund: 9422,
		pensionScheme: 9423,
		createNewVersion: 2197,
		create: 355,
		check: 4321,
		addNewContractVersion: 2202,
		candidateContract: 5096,
		CantCreateNewContractVersion: 5097,
		checkMatchedCandidateContracts: 5121,
		noMatchedCandidateContracts: 5122,
		youCanCheckOnFlexService: 5123,
		calculationSchemeConnectionErrorMessage: 7121,
		checkOnFlexService: 5128,
		period: 63,
		calculationScheme: 4487,
		caoFunction: 879,
		jobTitle: 459,
		wageCao: 259,
		wageWml: 260,
		costCenter: 701,
		purchaseOrderNumber: 710,
		target: 263,
		signal: 264,
		block: 265,
		minimal: 266,
		maximal: 267,
		workingHoursPerWeek: 5417,
		default: 268,
		bureau: 3156,
		bureauContactPerson: 1808,
		employer: 5,
		employerContactPerson: 1809,
		candidate: 13,
		contractConditions: 1804,
		remarks: 826,
		hoursPerWeek: 877,
		hoursTotal: 878,
		workPattern: 876,
		parties: 1807,
		workTimeDescription: 881,
		years: 1652,
		createContract: 1117,
		createContractMWHeader: 9225,
		found: 1846,
		showMore: 1848,
		createContractManually: 1852,
		documentAddedSuccessfully: 9507,
		labor: 874,
		activities: 256,
		documents: 318,
		options: 5191,
		filtersForSelectingModelMatrix: 5192,
		delete: 443,
		rejectContract: 993,
		rejectedReasonTip: 994,
		rateClassDeleting: 1889,
		areYouSure: 1890,
		thisContractWillBeDeletedPermanently: 1599,
		confirmationBackToTitle: 5189,
		confirmationBackToDescription: 5190,
		contractDetails: 5195,
		pay: 3504,
		contractDelete: 5196,
		rateClasses: 6806,
		addRateClass: 6685,
		selectModelMatrix: 1802,
		bureauOwner: 9424,
		contractPeriod: 2201,
		contractFunction: 464,
		cao: 465,
		regeling: 5223,
		phase: 2529,
		sector: 2531,
		model: 5460,
		addContract: 4034,
		textModel: 5461,
		type: 5462,
		contractMode: 5463,
		contractType: 5464,
		premiumGroup: 5465,
		signed: 348,
		targetHourWeek: 466,
		workingHoursWeek: 467,
		hourlyWage: 468,
		hourlyTariff: 469,
		margin: 470,
		marginPercent: 471,
		source: 5025,
		versionPeriod: 1863,
		assignmentType: 5091,
		juridicalAgency: 3535,
		unit: 3514,
		rateClass: 6801,
		activate: 2163,
		wageCap: 2334,
		approvalValidationMessage: 442,
		createNewContractVersion: 2200,
		clockwiseStatus: 527,
		contractIsSuccessfullyCreated: 494,
		laborSuccessfullyUpdated: 5201,
		thisFieldIsRequiredToCreateContract: 5202,
		thisFieldIsFilledCorrectly: 5203,
		checkForContract: 5209,
		calculationSchemeValidationMessage: 5164,
		fillInFieldsModalWindowExplanation: 5285,
		fillInFieldsToFill: 10534,
		importCAOWijzerWage: 8908,
		caoIsInvalidForThisPeriod: 2168,
		candidateContractDocument: 6295,
		addFillInFields: 6296,
		reactivateContract: 1891,
		areYouSureReactivate: 1892,
		manuallyAddedRejectedDocuments: 1893,
		byDefaultDocumentsDeleted: 1894,
		belowDocumentAreRejected: 1895,
		approvedSignedDocuments: 1896,
		byDefaultDocumentsStayInCurrentStatus: 1897,
		belowDocumentsAreApprovedSigned: 1898,
		employerContract: 1910,
		approvedDocumentsMessage: 1920,
		candidateContractTargetHoursValidation: 1921,
		activatingContractTitle: 1923,
		activatingContractDescription: 1924,
		calculationLogNotAllocated: 9994,
		variantCode: 4009,
		CAOTemporarilyNotAvailable: 4069,
		noCAOWagesAvailable: 4070,
		foundFormOuterErrors: 4029,
		copyContracts: 1938,
		contractPeriodEmployerContract: 1939,
		contractPeriodCandidateContract: 1940,
		sameDates: 1941,
		sameDuration: 1942,
		sameCandidate: 1943,
		otherCandidates: 1944,
		candidateName: 2089,
		contractPeriodNewContract: 2090,
		copyContractErrorForSomeEmployers: 2091,
		copyContractButtonsDescription: 2092,
		copyContractSelectCandidate: 2093,
		selectContractConditions: 2222,
		myContracts: 676,
		marginEuroSign: 1936,
		marginPercentSign: 1937,
		searchTip: 439,
		updateContractDuration: 11215,
		updateContractPeriod: 11236,
		newStartDate: 11237,
		newEndDate: 11238,
		linkedCCFound: 11239,
		updateCCPeriodExplanation: 11240,
		updateDuration: 11241,
		contractInformation: 11270,
		importDeal: 11300,
		noComponentsAvailable: 11346,
		endCandidateContract: 12233,
		rejectReason: 12392,
		rejectBy: 12393,
		createNewContractVersionError: 12651,
		action: 13137,
		deleteContractsPlural: 13138,
		toDelete: 13139,
		unableToDelete: 13140,
		deleteError: 13141,
		deleteSuccess: 13142,
		atPrepositions: 13143,
		selectedContractsDeleted: 13144,
		deleteResults: 13175,
		deleteContractsSingular: 13181,
		contractDeletionMessage: 13182,
		noContractsToDelete: 13184,
		reportTo: 13187,
		useExistingAddress: 13188,
		workAddress: 13189,
		agencyOwner: 13211,
		deleteAddress: 13357,
		deleteAddressConfirmation: 13358,
		update: 13825,
		updateContracts: 13826,
		tacitProlongationDays: 14857,
		tacitProlongationCount: 14859,
		contractWithDaysTacitProlongation: 14877,
		contractWithDaysTacitProlongationTipMessage: 14878,
		candidateIllness: 14979,
	},
	dateTime: {
		startDate: 333,
		endDate: 334,
		dateFormat: 335,
		wrongDateFormat: 415,
		period: 460,
		time: 482,
		days: 483,
		timeFormat: 485,
		daysOfWeek: 533,
		wrongTimeFormat: 550,
		timeFrom: 1039,
		timeTo: 1040,
		startDateFrom: 3082,
		startDateTo: 3083,
		yearsFormatted: 5142,
		monthsFormatted: 5143,
		daysFormatted: 5144,
		yearsCapital: 5051,
		years: 1702,
		months: 1703,
		month: 1705,
		yearFormat: 3000,
		weekFormat: 3001,
		year: 3006,
		week: 3007,
		periodFrom: 3080,
		periodTo: 3081,
		dateFromTo: 3457,
		hours: 6019,
		day: 9702,
		noEndDate: 11438,
		noStartSate: 11439,
		seconds: 16134,
	},
	apply: 283,
	bureaus: {
		singular: 3156,
		plural: 3157,
		addAgency: 1485,
		noAccessToAgency: 1487,
		matchOnEmail: 1501,
		parentOrganization: 1502,
		noMatchesFound: 1503,
		collapseAll: 1549,
		expandAll: 1832,
		structureSearchTip: 4402,
		structure: 4434,
		foundDuplicate: 4488,
		step: 4489,
		checkDuplicateOrAddNewBureau: 4490,
		general: 1120,
		presentation: 4422,
		faxNumber: 14027,
	},
	organization: {
		shortName: 37,
		legalName: 38,
		matchTotal: 43,
		matchOnKvK: 45,
		reminderAddress: 163,
		singular: 289,
		type: 1097,
		parent: 1098,
		address: 2400,
		postBox: 2401,
		owner: 5453,
		externalStatusName: 5398,
		invited: 5454,
		matchOnName: 6516,
		matchOnAddress: 6517,
		templatesTab: {
			templates: 5636,
			addTemplate: 5637,
			selectOrganizationType: 5638,
			whenShouldThisTemplateBeAdded: 5639,
			add: 5640,
			templatesDropdown: 5641,
			addTemplateMWHeader: 5642,
			updateTemplateMWHeader: 5645,
			inUse: 6449,
			notInUse: 6450,
			owner: 5648,
			inherited: 5649,
			noTemplates: 5650,
			criterium: 5643,
			templateType: 6444,
			organizationType: 5644,
			manageConditions: 11361,
			condition: 12928,
			conditions: 12933,
			defaultCondition: 12913,
		},
	},
	address: {
		postBus: 123,
		toAttention: 124,
		emailInvoice: 125,
		plural: 170,
		location: 596,
		unit: 1443,
		country: 2404,
		city: 2405,
		street: 2406,
		postalCode: 2407,
		number: 2408,
		fullAddress: 5312,
		fullAddressWithoutFind: 1855,
		billingAddress: 165,
	},
	logIn: 310,
	logOut: 311,
	endSession: 12841,
	profile: {
		male: 269,
		female: 270,
		notSpecified: 271,
		phone: 472,
		firstName: 486,
		lastName: 487,
		middleName: 489,
		salutation: 491,
		email: 797,
		gender: 819,
		deleteMyProfile: 1488,
		contactPerson: 2409,
		preferredName: 3360,
		skype: 3591,
		yourAccountWillBeDeleted: 2125,
		beforeYouDeleteKnowThis: 2126,
		youWillNotBeAbleToLoginAgain: 2127,
		yourProfileWillBeRemoved: 2128,
		weWillInformYou: 2129,
		thisActionCannotBeUndone: 2130,
		deleteProfile: 2131,
		firstNames: 4444,
		prefix: 4497,
		deleteProfileText: 5089,
		provideYourPassword: 14730,
		saveProfile: 14731,
		updateProfileWarningMessage: 14732,
	},
	documentUploader: {
		browse: 492,
		maxFileSize: 2120,
		dropFilesHere: 2123,
		uploadingCanceled: 2124,
		supportedExtensions: 1497,
		oneFileLimit: 2132,
		nFilesLimit: 2133,
		unknown: 4197,
		error: {
			size: 6043,
			required: 1435,
			maxNumberOfFilesExceeded: 2119,
			totalMaxSize: 2122,
		},
	},
	onlyValue: 9408,
	addCriterion: 9735,
	deleteHourTypeRule: 9736,
	editCriterion: 9737,
	criterion: 9738,
	deleteRuleText: 9739,
	deleteCriterionText: 9742,
	deleteCriterion: 9743,
	mySettings: 2115,
	filters: {
		main: 10526,
	},
	savedFilter: {
		alert: 15,
		time: 482,
		days: 483,
		frequency: 502,
		itemsType: 503,
		sms: 798,
		module: 1122,
		showOnDashboard: 1123,
		myFilters: 1125,
		ownFilters: 1127,
		adminFilters: 1126,
		default: 1128,
		singular: 1129,
		plural: 1130,
		clearFilter: 1132,
		fixedDate: 2044,
		flexible: 2045,
		onlyWorkdays: 2051,
		every: 2052,
		startsFrom: 2053,
		selectDay: 2054,
		smsMessage: 2109,
		exportToLibrary: 2112,
		importToLibrary: 2113,
		actionRequired: 3013,
		export: 3564,
		saveFilter: 8960,
		deleteFilter: 8962,
		editFilter: 8961,
		priority: 8951,
		editFilterPreset: 8961,
		saveFilterPreset: 8963,
		deleteWarning: 10517,
		internalDescription: 12852,
	},
	comment: {
		more: 1233,
		less: 1234,
		comments: 5076,
		rejected: 5296,
		addPersonToNotify: 8453,
		someUsersNotHaveAccess: 8454,
		notifiedPerson: 8455,
		historyIsTemporaryUnavailable: 11489,
	},
	timeCards: {
		addVariableExpense: 526,
		amount: 726,
		plural: 705,
		payAmount: 706,
		payAmountVariableExpense: 9925,
		payBill: 707,
		comments: 716,
		copyTimecard: 2273,
		copyTimecardQuestion: 2274,
		deleteVariableExpense: 5130,
		deleteVariableExpenseText: 6754,
		commentsTextArea: 5131,
		editVariableExpense: 5132,
		minValueValidationMessage: 6674,
		maxValueValidationMessage: 6675,
		descriptionRateClass: 5234,
		rateClass: 6805,
		attachDocument: 6755,
		notANumber: 416,
		wrongRealNumberAccuracy: 1669,
		resetDefault: 6731,
		resetDefaultQuestion: 6732,
		newCalculationSchemeUpdateAvaliable: 6752,
		hasAnotherCalculationScheme: 9822,
		inputTimeType: 9827,
		inputTimeTab: 6779,
		timeFrom: 9828,
		timeTo: 9829,
		timePause: 9830,
		timeWorked: 9831,
		remark: 9832,
		isContinuedInfo: 9833,
		selectInputTimeType: 9834,
		addRemark: 9835,
		saved: 9836,
		saving: 9840,
		total: 698,
		totalHours: 10365,
		invoiceHours: 10366,
		phaseNotFound: 1282,
		phase: 1284,
		phaseWeeks: 1283,
		source: 6604,
		wageProcessingStatus: 6706,
		invoiceProcessingStatus: 6707,
		nonAccurateCostPrice: 6670,
		realCostPrice: 6669,
		discount: 6668,
		revenu: 6667,
		purchaseOrderNumber: 710,
		costCenter: 711,
		version: 6671,
		calculationScheme: 9454,
		week: 3007,
		contract: 315,
		cao: 465,
		targetHours: 466,
		workingHours: 467,
		rejectModalTitle: 715,
		rejectReasonTip: 714,
		timecardsDetails: 9841,
		pauseTimeMustBeLessThanWorkTime: 9842,
		changed: 6659,
		illness: 6719,
		officialHoliday: 6652,
		hours: 695,
		editRateClass: 6695,
		deleteRateClass: 6694,
		expensesAndAllowances: 696,
		unit: 725,
		totalPay: 9847,
		totalBill: 9848,
		discardChangesErrorTitle: 6717,
		discardChangesErrorDescription: 6718,
		totalHoursADayErrorMessage: 6660,
		shouldBeEqualOrMoreThan: 6674,
		shouldBeEqualOrLessThan: 6675,
		expenses: 9844,
		expensesTab: 6780,
		allowances: 9845,
		hoursLowerCase: 1752,
		expensesAllowances: 696,
		stopAutoCalculation: 6715,
		summary: 2416,
		selectDay: 2054,
		noExpensesOrAllowancesAdded: 6762,
		noHoursAdded: 6761,
		pressPlusButtonToAddHours: 6785,
		empty: 9627,
		areYouSure: 9563,
		addRateClass: 6685,
		general: 6522,
		overview: 9846,
		documents: 6605,
		information: 793,
		isSeparatedMsg: 6739,
		doNotSaveAsDefault: 6738,
		submitAsDefaultTitle: 6726,
		submitAsDefaultDescriptionOne: 6727,
		submitAsDefaultDescriptionTwo: 6737,
		doYouWantToAddDefaultHours: 6735,
		applyDefaultHours: 6734,
		doNotAskMeAgain: 6730,
		inputTime: 6764,
		editHours: 6757,
		editExpenses: 6758,
		invoiceAttachment: 1372,
		deleteDocument: 2176,
		download: 8911,
		uploadFileDocument: 6607,
		documentName: 1470,
		timecardStatusIsChangedToReport: 6765,
		yourChangesAreSavedAndPageWillBeRefreshed: 6766,
		deleteHours: 6759,
		deleteExpenses: 6760,
		totalHoursThisWeek: 6769,
		totalHoursPerDay: 6770,
		rateClassWasDeleted: 6768,
		noneOfTheDaysIsSelected: 6767,
		hoursWillBeAddedSimultaneouslyToAllSelectedDays: 6772,
		youCanSelectMultipleDaysAtTheSameTime: 6773,
		addHoursExpenses: 6756,
		expAllow: 6751,
		totalAmount: 6771,
		cannotAddHoursToThisDay: 6763,
		saveAndAddNew: 6774,
		noDocumentsAdded: 6775,
		editDocument: 6776,
		documentDownload: 6777,
		uploadFile: 6778,
		calculatedHours: 9853,
		addHoursPlaceholder: 6785,
		addInputTimePlaceholder: 6786,
		addInputTime: 6781,
		editInputTIme: 6782,
		deleteInputTime: 6783,
		selectInputTime: 6784,
		notAvailableComponent: 6787,
		noTimeIntervalAdded: 6788,
		calculationLog: 9982,
		showCalculationLog: 9983,
		compensateOvertimeTittle: 9996,
		compensateOvertimeMessage: 9997,
		correctionReason: 6789,
		correctedBy: 12385,
		reason: 12386,
		timecardCorrectionType: 6798,
		correctionReasonDescription: 6790,
		timeType: 6791,
		timeGroup: 6792,
		files: 9965,
		timeCardEntityStateChangeReason: 10336,
		timeCardEntityStateChangeChangeReason: 10337,
		timeCardEntityStateChangeCancelReason: 10338,
		cancelBy: 12387,
		timecardMakeCorrectionTitle: 6799,
		changePayAndBill: 10339,
		changePayAndBillDescription: 10344,
		timecardMultipleDelete: 10346,
		timecardMultipleDeleteNoActionTimecards: 10347,
		timecardMultipleDeleteMoreThenTopItems: 10348,
		timecardMultipleDeleteListTitle: 10349,
		timecardMultipleDeleteConfirmationOK: 10350,
		timecardMultipleDeleteErrorNoTimecards: 10351,
		timecardListDeleteConfirmation: 10357,
		timecardDetailsEditQuantity: 10358,
		approveModalTitle: 10393,
		noTimecardsToApprove: 10394,
		toApprove: 10395,
		noActionTimecards: 10396,
		moreThanTop: 10397,
		msgSuccessSend: 833,
		approveConfirmation: 10405,
		rejectConfirmationSuccess: 834,
		noTimecardsToReject: 10407,
		listTitleReject: 10408,
		noActionTimecardsToReject: 10409,
		limitsTimecardToReject: 10410,
		toEmail: 3343,
		ccEmail: 3344,
		bccEmail: 3345,
		subject: 3346,
		messageContent: 3347,
		attachmentType: 3348,
		timecardMultiActionApprove: 10392,
		timecardMultiActionSubmit: 10535,
		timecardMultiActionSubmitModalTitle: 10536,
		timecardMultiActionSubmitListTitle: 10538,
		timecardMultiActionSubmitNoTimecards: 10537,
		timecardMultiActionSubmitNoActionTimecards: 10539,
		timeCardsRejectTitle: 10592,
		requestingDraftPayslip: 10826, // Requesting draft payslip
		pendingTip: 10827, // This might take a while. Please, don’t close the window.
		requestingDraftPayslipError: 11155, // Sorry, some error appeared during requesting
		requestDraftPayslipError: 10833, // Request draft payslip
		tryAgain: 10834, //Try again
		multiRecalculateTitle: 11098, // Recalculate timecards
		multiRecalculateNotRecalculate: 11099, // timecards can not be recalculated
		multiRecalculateToRecalculate: 11100, // To recalculate
		multiRecalculateNoTimecardsToRecalculate: 11101, // No timecards to recalculate
		multiRecalculateTimecardsRecalculateConfirmOK: 11102, // Timecards will be recalculate
		multiRecalculateMoreThanTop: 11103, // Only the first 30 declarations will be recalculate
		kind: 12183, // Kind
		rejectReason: 12383, // reject reason
		rejectBy: 12384, // reject by
		thisActionCanNotBeUndone: 13180,
		deleteRateclass: 13183,
		variableExpenseWillBeDeleted: 13191,
		warningTruncated: 14006,
		candidateType: 14386,
		notAvailableComponentExplanation: 14865,
	},
	user: {
		singular: 3,
		plural: 4,
		newPassword: 275,
		confirmNewPassword: 277,
		password: 305,
		rememberMe: 306,
		login: 310,
		wrongLogIn: 312,
		firstName: 486,
		lastName: 487,
		middleName: 489,
		salutation: 491,
		prefixSurname: 489,
		oneTimePinCode: 581,
		wrongPinCode: 583,
		idDocumentNumber: 585,
		wrongIdDocumentNumber: 586,
		idDocumentExpirationDate: 587,
		wrongIdDocumentExpirationDate: 588,
		inviteUser: 625,
		myUsers: 681,
		sessionExpired: 727,
		loginCooldown: 728,
		identityProvider: 749,
		wrongLoginUseAdfs: 750,
		logInWithADFS: 752,
		userName: 781,
		gender: 819,
		confirmPassword: 906,
		confirmPasswordValidation: 908,
		atLeast1NumericCharacter: 909,
		atLeast1SpecialCharacter: 910,
		atLeast1AlphabeticCharacter: 911,
		passwordNotUniqueDescription: 913,
		pleaseCheckYourMobilePin: 915,
		pleaseEnterYourPersonalData: 916,
		pinCodeAttemptsExceeded: 918,
		personalDataNotFound: 974,
		documentPersonalization: 997,
		registerPassword: 999,
		passwordWillExpireAfter: 1001,
		forYourOnlineSafetyWeRequireTheFollowingPasswordConditions: 1000,
		atLeastCharactersLong: 1004,
		searchTip: 1060,
		pleaseCheckYourEmail: 2397,
		contactPerson: 2409,
		forgotYourPassword: 2385,
		forgotPasswordSendEmailTip: 2387,
		expiredPasswordDescription: 3025,
		pleaseRegisterYourNewPassword: 3026,
		thisAccountIsBlockedOrInactive: 3158,
		multipleOrganizationConflictMessage: 3170,
		preferredName: 3360,
		nationality: 3365,
		maritalState: 3366,
		bankAccountNumber: 3368,
		bankAccountName: 3369,
		birthName: 3361,
		birthDate: 3364,
		initials: 3529,
		title: 3530,
		accountExpirationDate: 5198,
		emailConflictValidationMessageError: 5452,
		confirmationDeleteTitle: 5487,
		confirmationDeleteDescription: 5488,
		activateUser: 8440,
		multiActionTitle: 8441,
		usersAreActivated: 8442,
		cannotFindPhone: 9863,
		forgotPassword: 9864,
		twoStepAuthentication: 9865,
		enterAuthenticationCode: 9866,
		enterTheCodeFromAnAuthenticatiorApp: 9867,
		rememberThisComputerForNDays: 9868,
		verify: 9869,
		wrongAuthCode: 9870,
		downloadAuthenticatiorApp: 9871,
		downloadAuthenticatiorAppDescription: 9872,
		scanTheQRCode: 9873,
		scanTheQRCodeDescription: 9874,
		orEnterTheNextCodeInTheApp: 9875,
		toSecureYourAccountDescription: 9877,
		authCodeRetriesError: 9879,
		resendOneTimePinCode: 9880,
		resendOneTimePinCodeIn: 9881,
		backToLoginPage: 9882,
		resetAuthenticatorApp: 9894,
		resetAuthenticatorAppConfirmation: 9895,
		publicRegistrationFormButton: 9934,
		publicRegistrationFormTitle: 9935,
		publicRegistrationFormInfoMessage: 9937,
		publicRegistrationOfficeInfoMessage: 9936,
		authenticateWithAzureAd: 10388,
		usersActivated: 10856,
		usersActivatedSuccessfully: 10857,
		tooMuchUsersActivationWarning: 10858,
		toActivate: 10865,
	},
	navigation: {
		admin: 313,
		help: 14939,
		learnings: 14940,
	},
	caoWijzer: {
		years: 1652,
		cao: {
			singular: 1662,
			caoName: 1668,
		},
	},
	formDesigner: {
		addForm: 7615,
		formType: 7616,
		formName: 7617,
		bureau: 7618,
		inUse: 7108,
		notInUse: 7109,
		general: 7619,
		designer: 7612,
		copyForm: 7621,
		action: 7620,
		noDescriptionAdded: 7622,
		textFieldDefaultLabel: 7604,
		popupDeleteFormHeader: 7626,
		popupDeleteFormContent: 7625,
		popupCopyFormHeader: 7628,
		popupConfirmButtonText: 7629,
		showCountriesFlag: 8377,
		formTypeOnGeneralTab: 7634,
		requiredAuthentication: 7672,
		requiredAuthenticationTooltip: 7673,
		inUseTooltip: 7674,
		daysBeforeExpiration: 7683,
		daysBeforeExpirationTooltip: 7687,
		theme: 7695,
		image: 7696,
		uploadImage: 7697,
		noImage: 7698,
		themeColor: 7699,
		backgroundColor: 7700,
		preview: 7706,
		mobilePhone: 7707,
		computer: 7708,
		formPreview: 7709,
		copyLinkToClipboard: 7716,
		copiedToClipboard: 7723,
		applyViaCV: 7724,
		defaultForm: 7765,
		defaultFormTooltip: 7766,
		useLogoForForm: 11080,
		useLogoForFormTooltip: 11081,
		logo: 11082,
		bureauOrEmployer: 12165,
	},
	forms: {
		expired: 7641,
		dateSent: 7643,
		dateCompleted: 7644,
		name: 7647,
		status: 7648,
		user: 7649,
		defaultDescriptionPlaceholder: 7635,
		sendForm: 8426,
		publicFormSaveAsDraftSuccessMessage: 8427,
		publicFormSaveAsDraft: 8428,
		publicFormSubmit: 8429,
		approve: 7654,
		create: 7656,
		createNewCandidate: 7657,
		candidateOpenRegistrationModalTip: 16282,
		doYouWantToCreateNewCandidate: 7658,
		compare: 7659,
		submit: 7660,
		selectAll: 7661,
		compareAttributes: 7662,
		attributes: 7663,
		current: 7664,
		new: 7665,
		emailUpdateWarningTitle: 7666,
		emailUpdateWarningMessage: 7667,
		noDataToCompare: 7671,
		searchPlaceholder: 7668,
		listEntityName: 7669,
		resendConfirmationQuestion: 7701,
		resend: 7703,
		resendConfirmationTitle: 7704,
		rejectConfirmationMessage: 7713,
		rejectConfirmationTitle: 7714,
		delete: 7725,
		deleteConfirmationTitle: 7726,
		deleteConfirmationMessage: 7727,
		missingDocumentTooltipMessage: 7750,
		missingDocumentsWarningTitle: 7751,
		missingDocumentsWarningMessage: 7752,
		bureau: 10247,
	},
	community: {
		noDescription: 1603,
	},
	role: {
		singular: 1,
		plural: 2,
		organizationType: 2402,
		default: 3174,
	},
	assignment: {
		addAssignment: 3087,
		assignmentFormQuestion: {
			birthName: 5004,
			title: 5045,
		},
		caoNoWages: 1550,
	},
	tooltip: {
		multiRecalculate: 11096,
		compactMultiDetailView: 379,
		inviteUser: 3572,
		export: 3564,
		print: 3565,
		email: 3566,
		import: 3582,
		sendEmail: 5101,
		approve: 3567,
		reject: 3568,
		addLabel: 5428,
	},
	document: {
		required: 300,
		singular: 317,
		plural: 318,
		iHaveReadThisDocument: 336,
		pleaseCheckYourPhoneForSMS: 580,
		pleaseEnterYourPersonaData: 593,
		myDocuments: 677,
		signDocument: 766,
		viewDocument: 767,
		sign: 842,
		category: 843,
		signLevel: 905,
		rejectedReasonTip: 995,
		rejectDocument: 996,
		documentName: 1470,
		areYouSureYouWantToDeleteThisDocument: 1484,
		subtype: 1499,
		daysToEndDate: 2102,
		deleteDocument: 2176,
		country: 2404,
		searchTip: 2456,
		dateFrom: 3455,
		dateTo: 3456,
		daysAfterCreateDateFrom: 3483,
		daysAfterCreateDateTo: 3484,
		manyEmployers: 3494,
		manyCandidates: 3495,
		daysAfterApprovedDate: 3618,
		noDocumentsAvailable: 5200,
		initialStatusSign: 5215,
		pleaseSelectDocumentType: 5282,
		shouldThisDocumentBePublishedOrSigned: 5284,
		pleaseSelectForWhoYouWantToUploadDocument: 5386,
		forWhoDoYouWantToUploadDocument: 5387,
		both: 5388,
		currentlyNotPossibleEditDocument: 5654,
		signAgreement: 6297,
		editDocument: 6776,
		download: 8911,
		addDocument: 9505,
		documentType: 9506,
		source: 9514,
		documentDetails: 9926,
		openingDocument: 9928,
		documentNotDisplayed: 9929,
		documentDisplayError: 9930,
		documentDisplayWaitMessage: 9931,
		signLevelFixed: 1496,
		requiredInWorkflow: 2178,
		requiredFixed: 2179,
		allowMultipleFiles: 2173,
		allowMultipleFilesToolTip: 2174,
		storagePeriodDays: 1558,
		initialStatus: 1498,
		subtypeDomain: 1500,
		settingDetails: 2215,
		enablePreview: 2218,
		settingAttributes: 2219,
		signLevelFixedToolTip: 2220,
		requiredFixedToolTip: 2221,
		requiredToolTip: 10702,
		enablePreviewToolTip: 10703,
		settingFiles: 10704,
		biggerDateValidation: 11160,
		lessDateValidation: 11161,
		HRXMLCode: 11244,
		inUse: 11245,
		signInUse: 13600,
		parent: 11202,
		documentTypeName: 11288,
		documentNamePlaceholder: 11331,
		documentIdCheckTip1: 11459,
		documentIdCheckTip2: 11460,
		documentIdCheckTip3: 11461,
		documentIdCheckTip4: 11462,
		documentIdCheckTip5: 11463,
		documentIdCheckTip6: 11464,
		documentIdCheckTip7: 11465,
		documentIdCheckTip8: 11466,
		documentIdCheckTip9: 11467,
		documentIdCheckTip10: 11468,
		iDVerification: 11469,
		verifyDocument: 11470,
		verifyDocumentTips: 11471,
		verificationStarted: 11472,
		verificationRefresh: 11473,
		verificationRetry: 11474,
		verificationErrorMessage: 11475,
		verificationSuccessMessage: 11476,
		verificationFalsifiedMessage: 11477,
		verificationWarningMessage: 12176,
		verificationExtractedInformation: 11478,
		selectIdDocument: 11479,
		selectFrontCover: 11481,
		selectBackCover: 11483,
		updateRecords: 11487,
		verifiedStatus: 11490,
		verifiedDate: 11491,
		requestDate: 11514,
		extractedInfoError: 11989,
		firstName: 11990,
		surname: 11991,
		ssn: 11992,
		dateOfBirth: 11993,
		gender: 11994,
		documentNumber: 11995,
		emitCountry: 11998,
		nationality: 11999,
		verificationStatus: 12149,
		documentSizeValidationError: 12155,
		current: 12159,
		new: 12160,
		documentVerifiedStatus: 11480,
		documentWarningStatus: 11482,
		documentFailedStatus: 11484,
		documentNotStartedStatus: 11485,
		documentPendingStatus: 11486,
		documentTechnicalErrorStatus: 11488,
		verificationUnstartedTitle: 12175,
		noVerificationAccessMessage: 12177,
		approveManually: 12181,
		reasonForApproving: 12184,
		documentIsApprovedByAgency: 12185,
		approvedByAgency: 12180,
		downloadPDFReport: 12225,
		downloadPDFReportButton: 12664,
		userName: 12247,
		vehicleType: 12304,
		driverLicenseType: 12325,
		verifyDocumentWithIdCheck: 12281,
		notAutomaticallyVerified: 12263,
		type: 12361,
		vehicleTypeData: 12368,
		signReport: 12511,
		allowSignReportToolTip: 12544,
		signWithoutUserAccount: 12751,
		signWithoutUserAccountTooltip: 12767,
		addPublicSignee: 12848,
		addPublicSigneeTip: 12849,
		contactPerson: 12850,
		phoneForSMS: 12851,
		addPhoneNumber: 12853,
		notPossibleToUpdateDocTypeMessage: 12866,
		contactpersonDoesNotHavePhone: 12893,
		userIsActiveTip: 12895,
		signee: 12896,
		notificationSentToContact: 12903,
		entityStateNotAllowed: 12904,
		editSigneesList: 12914,
		publicSignees: 12916,
		noPublicSignees: 12934,
		clickEditButtonToAddSignees: 12935,
		SSNDoesNotMatch: 12997,
		documentNationalityDoesNotMatch: 12998,
		sendRemind: 13198,
		sendNotificationFrom: 13634,
		detailSignInUseToolTip: 13638,
		uploadDocument: 13784,
		fileUploadedSuccessfully: 13785,
		iDCheckError: 13786,
		storagePeriodCreatedDate: 14350,
		storagePeriodCreatedDateTip: 14358,
		storagePeriodEndDateTip: 14359,
		storagePeriodEndDateWarningMessagee: 14375,
		publishingDisabled: 14489,
		publishingDisabledTip: 14759,
		publishedStatusTipMessage: 14760,
	},
	settings: {
		purchaseOrderNumberRequired: 33,
		phase: 60,
		defaultActiveStatusEmployerContactPerson: 145,
		marginMinEuro: 432,
		marginMaxEuro: 433,
		marginMinPercent: 434,
		marginMaxPercent: 435,
		plural: 738,
		bureauUserIdentityProvider: 747,
		adfsUrlEndpoint: 748,
		generalSettings: 769,
		automaticallyApproveDocuments: 771,
		documentSettings: 772,
		automaticallyApproveContracts: 774,
		documentCheckCandidateDocumentNumber: 776,
		documentCheckCandidateDocumentEndDate: 777,
		checkTheSocialSecurityNumberOfTheCandidate: 778,
		automaticallySignDocuments: 780,
		contractSettings: 779,
		candidateType: 895,
		applicationGDPRSingleUse: 896,
		applicationGDPRMultiUse: 897,
		applicationGDPRSingleUseAutoDeleteStatuses: 898,
		applicationSettings: 899,
		calculateCostprice: 1386,
		addAttachmentToInvoice: 1465,
		checkOtpBySmsForCustomerUsers: 1554,
		gDPRSingleUseTooltip: 1564,
		gDPRMultiUseTooltip: 1565,
		gDPRStatusesTooltip: 1566,
		costCenterRequiredForContract: 1604,
		signInUse: 1735,
		autoApproveModelMatrixChanges: 1934,
		autoApproveModelMatrixChangesMessage: 1935,
		defaultStatusAndActivationSettings: 2017,
		deleteIDAndSSNAfter4Weeks: 2084,
		documentFileMaxSize: 11169,
		documentFileMaxSizeTooltip: 11170,
		documentFileMaxSizeValidation: 11171,
		iDAndSSNWillBeAutomaticallyDeletedAfter4Weeks: 2085,
		passwordSettings: 2492,
		passwordCandidateUserSMS: 2495,
		passwordMaximumAge: 2496,
		passwordMinimumLength: 2497,
		passwordUniqueness: 2498,
		signatureTopPosition: 2519,
		signatureLeftPosition: 2520,
		signatureWidth: 2521,
		signatureHeight: 2522,
		internalNotificationType: 2526,
		notificationsSection: 2526,
		category1SignLevel: 3033,
		category2SignLevel: 3034,
		category3SignLevel: 3035,
		category4SignLevel: 3036,
		category5SignLevel: 3037,
		automaticallyInviteNewCandidates: 3342,
		inheritedFrom: 3488,
		timecardSettings: 3423,
		useFromParent: 3531,
		useForChildren: 3532,
		allowContractCreationForAllEmployerTooltip: 4046,
		allowContractCreationForAllEmployer: 4047,
		CAORegelingListOptions: 4077,
		CAORegelingListOptionsTooltipMessage: 4078,
		CAOWijzerRequestOptions: 12503,
		CAOWijzerRequestOptionsTooltipMessage: 12508,
		jobCategoriesLevel: 4124,
		jobSettings: 4309,
		applyURL: 4354,
		applyURLPattern: 4355,
		applyUrlPatternTooltip: 4358,
		automaticallyUnpublishOrCloseJobs: 4360,
		jobStatus: 4361,
		specifyNumberOfDaysBeforeAboveAction: 4362,
		numberOfDaysForUnpublishCloseJobsTooltip: 4364,
		automaticallyDeleteJobs: 4365,
		jobEntityStatesTooltip: 4367,
		infoGDPRStoragePeriod: 4413,
		salutationGenderMale: 4442,
		salutation: 4436,
		signoff: 4437,
		salutationTip: 4445,
		signoffTip: 4446,
		defaultAssigmentTypeId: 4049,
		defaultAssigmentType: 4050,
		candidateGDPRStoragePeriod: 4461,
		salutationEmployer: 4521,
		salutationBureau: 4524,
		salutationFormalMale: 5148,
		salutationInformalMale: 5150,
		allowVariableExpenses: 5229,
		billFactor: 5233,
		pleaseSelectCandidateFieldsWhichShouldBeSecondApproved: 5289,
		candidateFields: 5290,
		defaultActiveStatusBureau: 5291,
		defaultActiveStatusEmployerDepartment: 5292,
		secondApproveCandidateChanges: 5295,
		bureauVisibleForPublicUsers: 5297,
		automaticallyInviteBureauUsers: 5310,
		automaticallyInviteEmployerUsers: 5311,
		contractWorkFlow: 5320,
		passwordEmployerUserSMS: 5424,
		passwordAgencyUserSMS: 5425,
		useStartAndEndTimes: 5466,
		showPrivacyStatementCheckinCandidate: 5508,
		automaticallyInviteNewCandidatesNewTimecard: 5521,
		automaticallyInviteNewCandidatesNewSignDocument: 5522,
		automaticallyInviteNewCandidatesNewPayslip: 5523,
		calculateCostpriceTooltip: 6374,
		candidateSettings: 6529,
		defaultContactPersonForPublicRegistrations: 6530,
		timecardAge: 6610,
		accessCandidates: 6602,
		secondApproveTimecards: 6625,
		totalHoursMoreThan: 6626,
		totalHoursADayMoreThan: 6627,
		totalBillMoreThan: 6628,
		totalPayIsMoreThan: 6629,
		secondApproveCorrection: 1387,
		automaticallyApproveIfBillIs0: 6741,
		automaticallyApproveIfPayIs0: 6742,
		activitySubject: 7039,
		surveySettings: 7433,
		approveBeforeSending: 7434,
		daysBeforeExpiration: 7435,
		surveyMaxRateForCommentRequired: 7442,
		requiredTimeFrameBetweenSurveys: 7451,
		automaticallyDeleteExpiredFormOlderThanXDays: 7730,
		numberOfDaysAfterExpiredFormToDeleteMessage: 7731,
		automaticallyApprovePublicRegistration: 8565,
		costCenterRequiredForTimecard: 8747,
		activitySettings: 9328,
		sendNotificationWhenCandidateIsRejected: 9371,
		showPrivacyStatementCheckinAssignment: 9522,
		requestRenewalRegistrationPeriod: 9528,
		requestRenewalRegistrationPeriodTooltip: 9549,
		automaticallyDeleteCandidatesGDPR: 9590,
		automaticallyDeleteCandidatesExplanation: 9591,
		twoFactorAuthCustomerUsers: 9858,
		twoFactorAuthAgencyUsers: 9859,
		twoFactorAuthEmployerUsers: 9860,
		twoFactorAuthCandidates: 9861,
		twoFactorAuthUsersTip: 9862,
		subscriptionSettings: 9896,
		foundationBundlePricePerBureauUser: 9897,
		secondBundlePricePerBureauUser: 9898,
		thirdBundlePricePerBureauUser: 9899,
		fourthBundlePricePerBureauUser: 9900,
		otherBundlePricePerBureauUser: 9901,
		azureAdClientId: 10386,
		azureAdTenantId: 10387,
		hasUnCompletedComment: 10520,
		normalHoursIsDifferent: 10521,
		hasUnCompletedCommentTip: 10531,
		normalHoursIsDifferentTip: 10532,
		employerVATNumberRequired: 11013,
		employerKvKNumberRequired: 11014,
		employerDateGeneralTermsRequired: 11015,
		candidateBankAccountRequired: 11016,
		candidateSSNRequired: 11017,
		candidateIdDocumentRequired: 11018,
		candidateIdDocumentShouldNotBeExpired: 11019,
		variantCodeRequired: 11020,
		candidateBankAccountCandidateType: 11021,
		candidateSSNRequiredCandidateType: 11022,
		candidateIdDocumentRequiredCandidateType: 11023,
		candidateIdDocumentShouldNotBeExpiredCandidateType: 11024,
		candidateToolOrEquipmentWillBecomeRequired: 13896,
		variantCodeOptions: 11025,
		contractValidations: 11028,
		employerVATNumberRequiredTooltip: 11029,
		employerKvKNumberRequiredTooltip: 11030,
		employerDateGeneralTermsRequiredTooltip: 11031,
		candidateBankAccountRequiredTooltip: 11032,
		candidateSSNRequiredTooltip: 11033,
		candidateIdDocumentRequiredTooltip: 11034,
		candidateIdDocumentShouldNotBeExpiredTooltip: 11035,
		variantCodeRequiredTooltip: 11036,
		candidateBankAccountCandidateTypeTooltip: 11037,
		candidateSSNRequiredCandidateTypeTooltip: 11038,
		candidateIdDocumentRequiredCandidateTypeTooltip: 11039,
		candidateIdDocumentShouldNotBeExpiredCandidateTypeTooltip: 11040,
		variantCodeOptionsTooltip: 11041,
		automaticallySentContractForm: 11271,
		automaticallySentContractFormTooltipMessage: 11311,
		isCandidateFullAddressRequired: 11353,
		isCandidateFullAddressRequiredCandidateType: 11354,
		isCandidateEmailAddressRequired: 11355,
		isCandidateEmailAddressRequiredType: 11356,
		candidateEmailAddressRequiredCandidateTypeTooltip: 11375,
		candidateFullAddressRequiredCandidateTypeTooltip: 11375,
		isCandidateEmailAddressRequiredTooltip: 11380,
		isCandidateFullAddressRequiredTooltip: 11381,
		calculationSchemeRequired: 12228,
		calculationSchemeRequiredTooltip: 12234,
		candidateIdDocumentVerified: 12229,
		candidateIdDocumentVerificationCandidateType: 12230,
		candidateIdDocumentVerificationReferenceDate: 12231,
		candidateIdDocumentVerifiedTooltip: 12235,
		candidateIdDocumentVerificationReferenceDateTooltip: 12236,
		invoicingSettings: 12400,
		parentCustomer: 12401,
		parentCustomerTip: 12402,
		childCustomersForBureauUsersInvoicing: 12403,
		childCustomersForBureauUsersInvoicingTip: 12404,
		foundationBundlePricePerExtraBureauUser: 12512,
		secondBundlePricePerExtraBureauUser: 12513,
		thirdBundlePricePerExtraBureauUser: 12514,
		fourthBundlePricePerExtraBureauUser: 12515,
		otherBundlePricePerExtraBureauUser: 12516,
		foundationBundleBureauUsersBudget: 12517,
		secondBundleBureauUsersBudget: 12518,
		thirdBundleBureauUsersBudget: 12519,
		fourthBundleBureauUsersBudget: 12520,
		otherBundleBureauUsersBudget: 12521,
		setBudgetAndExtraPrice: 12663,
		allowBillValueZero: 12875,
		sickRecoveryReportInReflexMessage: 12971,
		candidatePhaseIsPhaseAOrPhase1Or2: 12972,
		candidatePhaseIsPhaseAOrPhase1Or2Message: 12973,
		illnessBasedOnCandidateOrContractPhase: 12974,
		illnessBasedOnCandidateOrContractPhaseMessage: 12975,
		illnessSettings: 12976,
		whichValueOfReceiverIsSetOnBureauLevel: 12978,
		typeOfPhase: 12979,
		organizationForReportingSick: 12980,
		bureauUser: 13326,
		candidateSafetyExpirencyDateIsRequired: 13816,
		candidateSafetyExpirencyDateTools: 13817,
		candidateSafetyExpirencyDateEquipments: 13818,
		illnessMaxDaysAfterContractEnded: 13766,
		illnessMaxDaysAfterContractEndedMessage: 13767,
		hasRequiredCandidateDocumentType: 13796,
		requiredCandidateDocumentTypes: 13797,
		requiredCandidateDocumentCandidateTypes: 13798,
		requiredCandidateDocumentShouldNotBeExpired: 13799,
		requiredCandidateDocumentTypesTooltip: 13805,
		autoEnableCreditInsightsMonitoringList: 14247,
		employerActivationRequiredAttributes: 14289,
		employerActivationRequiredAttributesTip: 14318,
		requiredAttributesOfEmployer: 14319,
		defaultValuesForCreationEmployer: 14298,
		defaultValuesForCreationEmployerTip: 14320,
		documentOnlineEditor: 14368,
		isCandidateNationalityRequired: 14903,
		candidateNationalityRequiredCandidateType: 14904,
		isCandidateNationalityRequiredTooltip: 14907,
		candidateNationalityRequiredCandidateTypeTooltip: 14908,
		downloadAndUploadDocx: 15036,
		downloadUploadWordDocumentTooltip: 15043,
		wpnReportingRequired: 15069,
		wpnReportingRequiredTooltip: 15070,
		vpvCAOWijzerRequest: 15712,
		defaultPensionFund: 15871,
		defaultPensionFundId: 15906,
	},
	employer: {
		singular: 5,
		plural: 6,
		noAccessToEmployer: 34,
		kvkMainNumber: 39,
		kvkSubNumber: 40,
		mainAddress: 116,
		addCostCenter: 118,
		code: 119,
		isActive: 120,
		editCostCenter: 127,
		presentation: 223,
		isPublic: 224,
		activities: 256,
		searchTip: 297,
		myEmployers: 678,
		general: 1120,
		debtor: 1525,
		debtorStatus: 1527,
		debtorStatusDate: 1528,
		debtorStatusDescription: 1529,
		paymentTerms: 1530,
		vatNumber: 1531,
		vatCondition: 1532,
		vatRate: 1533,
		vatRateGroup: 10510,
		bankAccountNumber: 1534,
		bicCode: 1535,
		invoiceMethod: 1536,
		invoiceSchedule: 1537,
		invoiceEmail: 1538,
		secondaryInvoiceEmail: 10498,
		creditStatus: 1539,
		creditStatusDate: 1540,
		creditLimitAmount: 1541,
		creditLimitEndDate: 1542,
		creditStatusDescription: 1543,
		defaultCAO: 1544,
		marginWarning: 1545,
		marginBlocking: 1546,
		deliveryDate: 1547,
		website: 1548,
		addChildEmployer: 1552,
		addDepartment: 1553,
		checkTheDuplicateOrAddNewEmployer: 1850,
		noMatchesFoundBasedOnNameKvkOrAddress: 1851,
		addActivity: 1857,
		noCostCenter: 2139,
		addEmployer: 2468,
		unableToCreateContract: 4035,
		checkDuplicateOrAddNewEmployer: 5216,
		externalStatusName: 5398,
		customerNumber: 5401,
		debtorNumber: 5402,
		totalHoursPerWeek: 5417,
		tagsAndSkills: 8004,
		titleEmployerCalculationScheme: 9454,
		empty: 9627,
		addEmployerCalculationScheme: 9820,
		noEmployerCalculationSchemesAdded: 9923,
		regeling: 5223,
		cao: 5034,
		addCao: 6400,
		noCAOAvailable: 6407,
		editCAO: 6408,
		editEmployerCalculationScheme: 10311,
		employerCalculationSchemeDefault: 10312,
		calculationSchemeImportModalTitle: 10377,
		debtorGAccountUsage: 9222,
		debtorGAccountAmount: 9223,
		debtorGAccountInclusiveTAX: 9224,
		fixedBreakPlural: 10766, //Fixed breaks
		fixedBreakTimeDurationTooBig: 10769, // Time duration cannot be greater than 8 hours
		fixedBreakAddedResultMessage: 10770, // Fixed break added
		fixedBreakUpdatedResultMessage: 10771, // Fixed break updated
		fixedBreakDeletedResultMessage: 10772, // Fixed break deleted
		fixedBreakSingular: 10790, // Fixed break
		fixedBreakTimeFrom: 10791, //From
		fixedBreakTimeTo: 10792, //	To
		fixedBreakTimeIntervalOutOfDay: 10793, // Time interval is out of a day
		fixedBreakAddFixedBreak: 10794, // Add fixed break
		fixedBreakNoFixedBreaks: 10795, // NoFixedBreaks
		fixedBreakInherited: 10796, // inherited
		fixedBreakInheritedExplanation: 10797, // Fixed break is inherited. It will be copied for current employer
		fixedBreakHasIntersection: 10798, // There are intersections with other fixed breaks
		fixedBreakStatus: 10799, // in use status
		fixedBreakDayOfWeek: 10800, // days
		fixedBreakDayOfWeekRequiredExplanation: 10801, // You should choose at least one option
		fixedBreakEditFixedBreak: 10804, // edit fixed break
		fixedBreakDeleteFixedBreakQuestion: 10805, // Are you sure
		fixedBreakStatusInUse: 10809, // In use
		fixedBreakStatusNotInUse: 10810, //	Not in use
		contactPerson: 11064, // (bureau)
		addDeal: 11212,
		recommendedCreditLimit: 13315,
		creditInsightsRatingPercentageScore: 13317,
		creditInsightsPaymentScore: 13318,
		extraCreditAmount: 13319,
		creditInsured: 13321,
		calculatedExposureAmount: 13322,
		creditStatusTooltip: 13327,
		creditStatusDateTooltip: 13328,
		creditLimitAmountTooltip: 13329,
		creditLimitEndDateTooltip: 13330,
		creditStatusDescriptionTooltip: 13331,
		recommendedCreditLimitTooltip: 13332,
		creditInsightsRatingPercentageScoreTooltip: 13333,
		creditInsightsPaymentScoreTooltip: 13334,
		extraCreditAmountTooltip: 13335,
		creditInsuredTooltip: 13336,
		calculatedExposureAmountTooltip: 13337,
		creditReport: 13527,
		lastUpdatedCreditReport: 13528,
		lastUpdatedCreditReportTooltip: 13529,
		creditReportTooltip: 13530,
		na: 13582,
		DaysAfterCreditInsightsIsActivated: 13639,
		DaysAfterCreditInsightsIsActivatedTooltip: 13640,
		creditInsightsSettings: 13658,
		initialCreditStatus: 13659,
		maximumStandardCreditLimitAmount: 13660,
		initialCreditStatusTooltip: 13674,
		maximumStandardCreditLimitAmountTooltip: 13675,
		isRequiredForSending: 13702,
	},
	contactPerson: {
		singular: 2409,
		plural: 11285,
		searchTip: 11291,
		contactPersonBureau: 11293,
		externalStatusName: 11292,
		myContacts: 11294,
		contactPersonDetailEmailWarning: 8870,
		contactPersonDetailMobileWarning: 8871,
		contactPersonDetailReactivateWarning: 8872,
	},
	costCenter: {
		inUse: 120,
	},
	job: {
		singular: 1296,
		none: 535,
		age: 4107,
		published: 4205,
		nonSelected: 536,
		completeness: 4334,
		location: 596,
		jobLocation: 9512,
		acceptPrivacyStatementMessage: 892,
		plural: 1397,
		yearsOfExperience: 1702,
		assign: 1905,
		contactPerson: 2409,
		experienceLevel: 3616,
		industry: 3614,
		educationalLevel: 3615,
		matchingIsNotStartedYet: 4084,
		jobMatchingTooltipMessage: 4087,
		relevance: 4095,
		popularTags: 5331,
		popularSkills: 4500,
		lastWorkedDate: 4096,
		lastJob: 4097,
		addJob: 4110,
		myJob: 4400,
		applicationForm: 9434,
		selectOrCreatePrimarySkillPlaceholder: 4112,
		anonymousEmployer: 4113,
		calculatedSalaryPerMonth: 4145,
		jobType: 4146,
		hoursPerWeekRange: 4147,
		salaryRange: 4148,
		requirements: 4170,
		employment: 4199,
		searchOnCity: 4208,
		salary: 4211,
		period: 4219,
		dateCreated: 4220,
		custom: 4263,
		topJob: 4265,
		candidate: 4037,
		matchProfileMatchDetail: 4038,
		reload: 4068,
		ownership: 4298,
		unpublish: 4299,
		jobIsSuccessfullyUnpublished: 4300,
		jobIsSuccessfullyPublished: 4301,
		publish: 4308,
		primarySkills: 4317,
		hoursPerWeek: 4322,
		createdByEmployer: 4335,
		filters: 4341,
		closeJobRemoveJobPostsMessage: 4345,
		linkedIn: 4348,
		closeJob: 4343,
		closeJobUnpublishMessage: 4344,
		applyUrl: 4357,
		iscoJobFunction: 4369,
		copyBureauPresentation: 4370,
		copyEmployerPresentation: 4371,
		readyForPosting: 7230,
		shared: 7279,
		preview: 7706,
		tagsAndSkills: 8004,
		contactDetails: 9445,
		formName: 9453,
		jobPreferences: 9551,
		matching: 4276,
		matchProfile: 4094,
		startMatch: 4093,
		jobTitle: 8905,
		jobFunction: 9594,
		jobIndustry: 4092,
		employmentType: 4091,
		salaryType: 4088,
		area: 9583,
		notAvailable: 4079,
		matchResult: 4082,
		belowDetailsMatchResult: 4083,
		matchingSalaryRange: 4089,
		match: 4090,
		isRequired: 9053,
		noMatchedItems: 12543,
		applyUrlCopied: 12789,
		jobMatchRecipientsDescription: 13131,
		daysPublished: 15800,
	},
	seo: {
		singular: 129,
		title: 181,
		titleToolTipContent: 189,
		titleToolTipTitle: 190,
		slug: 191,
		slugToolTipContent: 192,
		slugToolTipTitle: 193,
		description: 194,
		descriptionToolTipContent: 195,
		descriptionToolTipTitle: 196,
	},
	tag: {
		plural: 2399,
		selectSkillPlaceholder: 4501,
		selectOrCreateNewTag: 5326,
		selectTag: 5349,
		noTagsAdded: 4527,
		noSkillsAdded: 4528,
		createNewTagValidationMessage: 4503,
		entityType: 5333,
	},
	activities: {
		type: 6536,
		plural: 6537,
	},
	calculationScheme: {
		plural: 9479,
		addAllowanceGroup: 9942,
		editAllowanceGroup: 9947,
		deleteAllowanceGroup: 9948,
		includePause: 9951,
		notIncludePause: 9952,
		groupBy: 9946,
		moveUp: 9949,
		moveDown: 9950,
		name: 9943,
		description: 9944,
		addAllowanceRule: 9979,
		deleteAllowanceGroupQuestion: 6794,
		noAllowanceCalculationGroupsAreAvailable: 9980,
		editCriterionResultMessage: 10313,
	},
	flexNet: {
		deleteConfirmation: 5624,
		flexNetHost: {
			singular: 4333,
			installation: 4375,
			instance: 4376,
			eventJournal: 4377,
			configuration: 4378,
			hostname: 4381,
			infoServicePort: 4382,
			connectorServicePort: 4383,
			userServicePort: 4384,
			lastOnlineDate: 4385,
			secret: 4386,
			accessToken: 4387,
			serviceName: 4388,
			serviceVersion: 4389,
			autoUpdate: 4390,
			logging: 4391,
			uptime: 4392,
			totalMemoryUsage: 4393,
			memoryUsage: 4394,
			totalCpuUsage: 4395,
			cpuUsage: 4396,
			threadsUsage: 4397,
			systemDriveFreeSpace: 4398,
			userServiceUri: 5261,
			currentSessions: 5262,
			failedAuthentications: 5263,
			successAuthentications: 5264,
			currentConnections: 5265,
			addNewHost: 5266,
			packageVersion: 5267,
			userService: 5273,
			connectorService: 5274,
			instanceCustomers: 5275,
			property: 5276,
			data: 5277,
			installationHeader1: 5278,
			installationHeader2: 5549,
			installationStep1: 5279,
			installationStep2: 5280,
			installationStep3: 5281,
			installationStep4: 5527,
			installationStep5: 5528,
			installationStep6: 5529,
			installationStep7: 5530,
			instanceInformation: 5531,
			level: 5532,
			source: 5533,
			message: 5534,
			eventLevel: 5535,
			dateFrom: 5536,
			timeFrom: 5537,
			count: 5538,
			dateTo: 5539,
			timeTo: 5540,
			addCustomer: 5554,
			setConfiguration: 5555,
			reloadConfiguration: 5556,
			restartService: 5557,
			customer: 5558,
			guid: 5559,
			username: 5560,
			password: 5561,
			flexConnectorUrl: 5562,
			reloadConfigurationModalMessage: 5563,
			restartServiceModalMessage: 5564,
			removeCustomer: 5565,
			removeCustomerModalMessage: 5566,
			remove: 5567,
			reload: 5568,
			restart: 5569,
			set: 5570,
			flexNetHostMinPortnumber: 5619,
			flexNetHostMaxPortnumber: 5620,
			flexNetHostSettings: 5621,
			deleteFlexNetHost: 5622,
			unableToDelete: 10846,
		},
		flexNetCustomer: {
			flexNetCustomerList: 4372,
			fSVersion: 4373,
			dBGuid: 4374,
			singular: 4380,
			addNewCustomer: 5550,
			supportUsername: 5552,
			supportPassword: 5553,
			logName: 5572,
			timeFilter: 5573,
			systemEventJournal: 5580,
			msmq: 5581,
			arrivedTime: 5582,
			bodySize: 5583,
			label: 5584,
			verwerkingLog: 5585,
			verwerkingID: 5586,
			verwerkingBeginDT: 5587,
			verwerkingEindDT: 5588,
			verwerkingStatusID: 5589,
			verwerkingOms: 5590,
			lastUpdDT: 5591,
			verwerkingUserNm: 5592,
			lastUpdUS: 5593,
			koppelingEnum: 5594,
			exporteertVanUitTabel: 5595,
			verwerkingLogId: 5596,
			logDt: 5597,
			logMelding: 5598,
			toolVerwerkingLog: 5599,
			toolVerwerkingID: 5600,
			toolVerwerkingBeginDt: 5601,
			toolVerwerkingEindDt: 5602,
			toolVerwerkingStatusId: 5603,
			toolVerwerkingBronId: 5604,
			toolVerwerkingOms: 5605,
			toolVerwerkingUserNm: 5606,
			toolVerwerkingProcesCd: 5607,
			toolVerwerkingPeriodeId: 5608,
			aanvraagDt: 5609,
			id: 5610,
			checksum: 5611,
			eTLRepository: 5612,
			exportTablesState: 5613,
			koppeling: 5614,
			stateId: 5615,
			state: 5616,
			stateDescription: 5617,
			count: 5618,
			deleteFlexNetCustomer: 5623,
			deleteConfirmation: 12902,
		},
	},
	textModel: {
		plural: 693,
		youCanCreateCustomDocumentNamePattern: 8011,
		isRequired: 8576,
		documentName: 9940,
		uploadDocument: 4013,
		additionalDocuments: 4014,
		addDocument: 4016,
		cancelDocument: 4017,
		editDocument: 4018,
		editDocumentName: 4019,
		editDefault: 4020,
		editSave: 4021,
		editDelete: 4022,
		editCancel: 4023,
		cannotChangeDefault: 4024,
		confirmDeleteFileTitle: 4025,
		confirmDeleteFileMessage: 4026,
		activateTacitProlongation: 14848,
		activateTacitProlongationTip: 14852,
		tacitProlongationDays: 14849,
		tacitlyRenewableContracts: 14851,
	},
	domainValue: {
		language: 515,
		industry: 3614,
		educationLevel: 3615,
		experienceLevel: 3616,
		processingType: 6568,
		documentEmployer: 6572,
		documentCandidate: 6573,
		inUse: 7108,
		type: 7111,
	},
	componentModel: {
		versionCreatedDate: 8448,
		previousVersion: 8449,
	},
	formData: {
		confirmationPageTitle: 7636,
		confirmationPageDescription: 7637,
		confirmationPageButton: 10288,
	},
	survey: {
		sendAdditionalSurvey: 7029,
		canNotSendAdditionalSurveyMessage: 7035,
		question: 7058,
		description: 7059,
		additional: 8725,
		custom: 8726,
		pleaseSelectSurveyType: 8731,
	},
	news: {
		plural: 1424,
		source: 1426,
		attachments: 1432,
		likes: 1448,
		like: 1452,
		liked: 3474,
		noNewsDescription: 3476,
	},
	connect: {
		messageKeyIndicator: 830,
		singular: 2462,
	},
	deals: {
		plural: 10588,
		general: 10599,
		name: 10600,
		period: 10601,
		version: 10602,
		update: 10603,
		addNewDeal: 10613,
		id: 10629,
		hours: 10627,
		component: 10630,
		HRXMLCode: 10631,
		payMultiplier: 10632,
		billCalculationType: 10634,
		billAmountLabel: 10635,
		billFactorLabel: 10636,
		billMultiplierLabel: 10637,
		marginAmountLabel: 10638,
		marginMultiplierLabel: 10639,
		isGeneral: 10640,
		duplicate: 10641,
		delete: 10642,
		addHour: 10643,
		duplicateHour: 10645,
		editHour: 10647,
		deleteHourTitle: 10649,
		deleteHourDescription: 10651,
		entityStateChangeBlockConfirmation: 10733,
		entityStateChangeDeleteConfirmation: 10734,
		billFactor: 10655,
		billMultiplier: 10656,
		billAmount: 10657,
		marginMultiplier: 10658,
		marginAmount: 10659,
		equalPayBill: 10660,
		notOptimizedTitle: 10715,
		notOptimizedDescription: 10716,
		notOptimizedAction: 10717,
		billInput: 10718,
		generalDescription: 10719,
		noItems: 10720,
		dealActionAddNewUpdate: 10773,
		dealActionCreateNewVersion: 10774,
		dealActionCreateNewVersionConfirmation: 10775,
		dealEntityStateChangeStartDateValidation: 10786,
		addAllowance: 10644,
		editAllowance: 10648,
		duplicateAllowance: 10646,
		deleteAllowance: 10650,
		payAmount: 10633,
		copyDeal: 11166,
		copy: 11198,
	},
	fsApiLog: {
		pageTitle: 5222,
		entity: 8647,
		code: 2141,
		technicalError: 2142,
		contractNumber: 2143,
		contractGUID: 2144,
		hfErrorCode: 2145,
		messageCategory: 5226,
		message: 827,
		customer: 786,
		searchTip: 2223,
	},
	outdatedApp: {
		modalTitle: 16328,
		applicationHasBeenUpdated: 16329,
		refreshTime: 16330,
	},
};
